import { render } from "./ReferralAction.vue?vue&type=template&id=23186310"
import script from "./ReferralAction.vue?vue&type=script&lang=js"
export * from "./ReferralAction.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__